import { useTranslation } from 'react-i18next';

const faqs = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
  { q: 'faq.q5', a: 'faq.a5' },
];

export default function FAQSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              {t('faq.title')}
            </h2>
            <p className="text-foreground-600 text-sm">
              Respostas para as dúvidas mais comuns sobre o CSSBuy Spreadsheet.
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-white rounded-lg border border-background-200/70 p-5">
                <h3 className="font-semibold text-foreground-900 mb-2 text-sm md:text-base">
                  {t(faq.q)}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {t(faq.a)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}